import { useQuery } from "@tanstack/react-query";

import { getCities } from "../../api/queries"

export const useCities = () => useQuery(["cities"], getCities);
